import React from "react";

/* ✅ Keep links in one place (optional but recommended) */
const CONTACT_ASSETS = {
  donateUrl: "https://givebutter.com/Nnf9Vr",
};

function ContactUsMediaPress() {
  return (
    <>
      <style>{`
        /* Keep everything visible (prevents blank issues caused by theme rules) */
        .cmp-wrap, .cmp-wrap * { box-sizing: border-box; }
        .cmp-wrap { display:block !important; visibility:visible !important; opacity:1 !important; height:auto !important; overflow:visible !important; }

        /* Ensure lists are left aligned */
        .cmp-wrap ul, .cmp-wrap ol, .cmp-wrap li { text-align:left !important; }

        /* Page surface */
        .cmp-surface {
          border-radius: 18px;
          padding: 18px;
          border: 1px solid rgba(255,255,255,0.12);
          background: radial-gradient(circle at 15% 0%, rgba(255,255,255,0.08), rgba(0,0,0,0) 50%),
                      rgba(255,255,255,0.05);
          box-shadow: 0 22px 80px rgba(0,0,0,0.30);
        }

        /* Cards */
        .cmp-card {
          margin-top: 18px;
          border-radius: 18px;
          border: 1px solid rgba(255,255,255,0.12);
          background: rgba(0,0,0,0.14);
          overflow: hidden;
        }
        .cmp-cardBody { padding: 16px; text-align: left; }

        /* Headings alignment request */
        .cmp-leftTitle { text-align: left !important; }

        /* Contact detail grid */
        .cmp-detailGrid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }
        .cmp-detail {
          border-radius: 16px;
          padding: 14px;
          border: 1px solid rgba(255,255,255,0.12);
          background: rgba(255,255,255,0.06);
        }
        .cmp-detail strong { display:block; margin-bottom: 6px; }

        /* Form styling */
        .cmp-form .form-control {
          background: rgba(255,255,255,0.10);
          border: 1px solid rgba(255,255,255,0.18);
          color: #fff;
          border-radius: 14px;
          padding: 12px 12px;
          box-shadow: 0 10px 35px rgba(0,0,0,0.18);
        }
        .cmp-form .form-control::placeholder { color: rgba(255,255,255,0.65); }
        .cmp-form .form-control:focus {
          outline: none;
          border-color: rgba(59,130,246,0.45);
          box-shadow: 0 14px 50px rgba(59,130,246,0.18);
        }

        .cmp-checkWrap {
          margin-top: 14px;
          padding: 14px;
          border-radius: 16px;
          border: 1px solid rgba(255,255,255,0.12);
          background: rgba(0,0,0,0.10);
        }

        /* Video placeholder */
        .cmp-video {
          width: 100%;
          height: 280px;
          border-radius: 18px;
          border: 1px solid rgba(255,255,255,0.14);
          background: linear-gradient(135deg, rgba(11,40,73,0.55), rgba(255,255,255,0.06));
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 18px 70px rgba(0,0,0,0.30);
          position: relative;
          overflow: hidden;
        }
        .cmp-video::after{
          content:"";
          position:absolute; inset:0;
          background: radial-gradient(circle at 20% 10%, rgba(255,255,255,0.18), rgba(0,0,0,0.75));
          pointer-events:none;
        }
        .cmp-video span{ position:relative; z-index:1; }

        /* Buttons */
        .cmp-btn {
          border: 0;
          border-radius: 14px;
          padding: 12px 16px;
          font-weight: 900;
          cursor: pointer;
          transition: transform 200ms ease, box-shadow 200ms ease, filter 200ms ease;
        }
        .cmp-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 20px 60px rgba(0,0,0,0.28);
          filter: saturate(1.05);
        }

        /* Responsive */
        @media (max-width: 768px) {
          .cmp-detailGrid { grid-template-columns: 1fr; }
        }
      `}</style>

      <section className="cmp-wrap">
        <div className="block color-scheme-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <div className="section-sub-title center">
                  <article className="section-title-body white cmp-surface">
                    <h1 className="head-title">
                      <span>CONTACT US</span>{" "}
                      <span>(WITH MEDIA &amp; PRESS)</span>
                    </h1>

                    <p className="head-text">Get in Touch</p>
                    <p className="white" style={{ textAlign: "left" }}>
                      We welcome inquiries from community members, volunteers,
                      media, partners, and organizations.
                    </p>

                    {/* CONTACT DETAILS */}
                    <div className="cmp-card">
                      <div className="cmp-cardBody">
                        <h3 className="white cmp-leftTitle">Contact Details</h3>

                        <div className="cmp-detailGrid">
                          <div className="cmp-detail">
                            <strong>General Inquiries</strong>
                            info@fogsv.org / info@americans4hindus.org
                            <br />
                            (Use your preferred unified email)
                          </div>

                          <div className="cmp-detail">
                            <strong>A4H &amp; Civic Engagement</strong>
                            contact@americans4hindus.org
                          </div>

                          <div className="cmp-detail">
                            <strong>Events &amp; Sponsorships</strong>
                            events@fogsv.org
                          </div>

                          <div className="cmp-detail">
                            <strong>Phone</strong>
                            (Insert main office line)
                          </div>

                          <div className="cmp-detail" style={{ gridColumn: "1 / -1" }}>
                            <strong>Office Address</strong>
                            (Insert HQ address)
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* CONTACT FORM */}
                    <div className="cmp-card">
                      <div className="cmp-cardBody">
                        <h3 className="white cmp-leftTitle">Contact Form</h3>

                        <form className="mt-3 cmp-form">
                          <div className="mb-3">
                            <input type="text" className="form-control" placeholder="Name" />
                          </div>
                          <div className="mb-3">
                            <input type="email" className="form-control" placeholder="Email" />
                          </div>
                          <div className="mb-3">
                            <input type="tel" className="form-control" placeholder="Phone" />
                          </div>
                          <div className="mb-3">
                            <input type="text" className="form-control" placeholder="Subject" />
                          </div>
                          <div className="mb-3">
                            <textarea className="form-control" rows="4" placeholder="Message" />
                          </div>

                          <div className="cmp-checkWrap text-start">
                            <div className="form-check">
                              <input className="form-check-input" type="checkbox" id="volunteer" />
                              <label className="form-check-label white" htmlFor="volunteer">
                                I want to volunteer
                              </label>
                            </div>

                            <div className="form-check">
                              <input className="form-check-input" type="checkbox" id="chapter" />
                              <label className="form-check-label white" htmlFor="chapter">
                                I want to join a chapter
                              </label>
                            </div>

                            <div className="form-check">
                              <input className="form-check-input" type="checkbox" id="updates" />
                              <label className="form-check-label white" htmlFor="updates">
                                I want event updates
                              </label>
                            </div>
                          </div>

                          <button type="button" className="btn btn-light mt-3 cmp-btn">
                            Submit
                          </button>
                        </form>
                      </div>
                    </div>

                    {/* MEDIA & PRESS */}
                    <div className="cmp-card">
                      <div className="cmp-cardBody">
                        <h3 className="white cmp-leftTitle">Media &amp; Press</h3>

                        <p className="white">
                          <strong>Press Releases</strong>
                          <br />
                          Official statements from FOG &amp; A4H.
                        </p>

                        <p className="white">
                          <strong>Media Coverage</strong>
                          <br />
                          News features, interviews, and articles.
                        </p>

                        <p className="white">
                          <strong>FOG TV Video Library</strong>
                          <br />
                          Event clips, interviews, cultural programs, training
                          modules, and festival recordings.
                        </p>

                        <p className="white">
                          <strong>Photo Galleries</strong>
                          <br />
                          High-quality albums from parades, competitions, film
                          festivals, leadership programs, and health fairs.
                        </p>
                      </div>
                    </div>

                    {/* PRESS KIT */}
                    <div className="cmp-card">
                      <div className="cmp-cardBody">
                        <h3 className="white cmp-leftTitle">Press Kit</h3>
                        <ul className="white" style={{ marginBottom: 0 }}>
                          <li>Organizational overview</li>
                          <li>Logos</li>
                          <li>Photos &amp; videos</li>
                          <li>Leadership bios</li>
                          <li>Event highlights</li>
                          <li>Contact card</li>
                        </ul>
                      </div>
                    </div>

                    {/* CONTACT PAGE VIDEO */}
                    <div className="cmp-card">
                      <div className="cmp-cardBody">
                        <h3 className="white cmp-leftTitle">Contact Page Video</h3>
                        <p className="white">
                          A 1-minute journalist-friendly reel summarizing the
                          organization, events, leadership presence, and mission —
                          ideal for media briefings.
                        </p>

                        <div className="cmp-video">
                          <span className="white">Contact Page Video Placeholder</span>
                        </div>
                      </div>
                    </div>

                    {/* DONATION */}
                    <div className="cmp-card">
                      <div className="cmp-cardBody">
                        <h3 className="white cmp-leftTitle">Support Our Work</h3>
                        <p className="white">
                          <strong>
                            Help us expand programs, serve communities, and
                            strengthen our national presence — support our work
                            today.
                          </strong>
                        </p>

                        <div className="mt-3 d-flex justify-content-center">
                          <a
                            href={CONTACT_ASSETS.donateUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-light cmp-btn"
                          >
                            Donate Now
                          </a>
                        </div>
                      </div>
                    </div>

                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactUsMediaPress;
